var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / BB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1132C7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0522A5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-BB",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#08379D",
    mask: "url(#mask-2)",
    x: 13.3333333,
    y: 0,
    width: 14.6666667,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#08379D",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 9.33333333,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy",
    fill: "#FFCC50",
    mask: "url(#mask-2)",
    x: 9.33333333,
    y: 0,
    width: 9.33333333,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.837692,6.27809143 C13.9421416,6.12450577 14.1125391,6.13122559 14.2084806,6.27809143 L15.1516675,7.72190857 C15.2519988,7.87549423 15.1770833,8.00000001 14.994779,8.00000002 L14.6718877,8.00000004 C14.4849093,8.00000005 14.3476563,8.14322922 14.3665133,8.33179924 L14.6334867,11.0015341 C14.6518115,11.1847818 14.8212891,11.3333333 15,11.3333333 L15,11.3333333 C15.1840949,11.3333333 15.4375,11.2302856 15.5740153,11.0952368 L15.759318,10.9119246 C15.892243,10.7804276 16,10.5303717 16,10.3355647 L16,9.67159677 C16,9.48477903 15.8958333,9.22916667 15.759318,9.09265137 L15.5740153,8.90734863 C15.4410903,8.77442365 15.4771684,8.61872165 15.6458333,8.56250001 L17.0208333,8.10416671 C17.1934223,8.04663706 17.3069919,8.14322922 17.2723118,8.33179924 L16.7813178,11.0015341 C16.7476165,11.1847818 16.6114636,11.4379578 16.4787057,11.5655823 L15.5749238,12.4344177 C15.4414971,12.5626853 15.1787109,12.6666667 15,12.6666667 L15,12.6666667 C14.8159051,12.6666667 14.6666667,12.8093567 14.6666667,13.003123 L14.6666667,13.6635437 C14.6666667,13.8493634 14.5239766,14 14.3302104,14 L13.6697896,14 C13.4839699,14 13.3333333,13.85731 13.3333333,13.6635437 L13.3333333,13.003123 C13.3333333,12.8173033 13.1787109,12.6666667 13,12.6666667 L13,12.6666667 C12.8159051,12.6666667 12.5620422,12.5620422 12.4344177,12.4344177 L11.5655823,11.5655823 C11.4373147,11.4373147 11.3046875,11.1901042 11.2669735,11.0015341 L10.7330265,8.33179924 C10.696377,8.14855161 10.8105017,8.04794507 10.9791667,8.10416671 L12.3541667,8.56250001 C12.5267557,8.62002967 12.5625,8.77083333 12.4259847,8.90734863 L12.240682,9.09265137 C12.107757,9.22557635 12,9.47678976 12,9.67159677 L12,10.3355647 C12,10.5223824 12.1041667,10.7768758 12.240682,10.9119246 L12.4259847,11.0952368 C12.5589097,11.2267339 12.8212891,11.3333333 13,11.3333333 L13,11.3333333 C13.1840949,11.3333333 13.3476563,11.1901042 13.3665133,11.0015341 L13.6334867,8.33179919 C13.6518115,8.14855156 13.5104167,8 13.3281123,8 L13.005221,8 C12.8182426,8 12.7559098,7.86877441 12.8557894,7.72190857 L13.837692,6.27809143 Z",
    id: "Line",
    fill: "#262626",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb);
export default __webpack_public_path__ + "static/media/BB.489427c0b56bbf0e9add6042d8d8a70e.svg";
export { ForwardRef as ReactComponent };